export default "__VITE_ASSET__B9QtzqK8__"